import { ChangeDetectionStrategy, Component, Input, booleanAttribute, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslocoCoreModule } from "@i18n";
import { FuseAlertModule } from "@vui/alert";
import { DigitalCertificateService } from "./digital-certificate.service";
import { MatButtonModule } from "@angular/material/button";
import { DIGITAL_CERTIFICATE_REGISTRATION } from "./digital-certificate-registration";

export const DIGITAL_CERTIFICATE_SETTINGS_ROUTE = "/account/signature";

@Component({
    selector: "digital-certificate-notice",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FuseAlertModule, TranslocoCoreModule, MatButtonModule],
    templateUrl: "./digital-certificate-notice.component.html",
})
export class DigitalCertificateNoticeComponent {
    private readonly _router = inject(Router);
    private readonly _hostDialogRef = inject(MatDialogRef, { optional: true });
    private readonly _registration = inject(DIGITAL_CERTIFICATE_REGISTRATION, { optional: true });

    @Input({ transform: booleanAttribute })
    blocking = false;

    readonly hasCertificate = inject(DigitalCertificateService).hasCertificate;

    registerCertificate() {
        if (this._registration) {
            this._registration.register();
            return;
        }

        this._hostDialogRef?.close();
        this._router.navigateByUrl(DIGITAL_CERTIFICATE_SETTINGS_ROUTE);
    }
}
